import React, { useState, useEffect } from 'react';
import styles from '../styles/Navbar.module.css'
import '../styles/Navbar.css';
import logo from '../assets/logo_blau.svg';
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from '../contexts/AuthContext';
import { use } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  /* const [activeLeftOffset, setActiveLeftOffset] = useState(0); */
  const { user, logout } = useAuth(); // ✅ доступ к имени и функции logout

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const location = useLocation();
  const activeNavLink = document.getElementById(location.pathname.split('/')[1]);
  console.log(activeNavLink);

  let activeWidth = 0;
  let activeLeftOffset = 0;

  if (activeNavLink) { 
    activeWidth = activeNavLink.clientWidth - 16;
    activeLeftOffset = activeNavLink.offsetLeft + 8;
  }
  
  /* 
  (activeNavLink) ? setActiveLeftOffset(activeNavLink.offsetLeft) : setActiveLeftOffset(-100);
 */
  return (
    <nav className={styles.navbar}>
      <div className={styles['navbar-container']}>
        <div className={styles['navbar-logo']}>
          <NavLink to="/" className={({isActive}) => (isActive ? "active" : "")}><img className={styles.logo} src={logo} alt="logo" /></NavLink>
        </div>
  
        <div
          className={`${styles['menu-icon']} ${isOpen ? styles.open : ''}`}
          onClick={toggleMenu}
        >
          <div className={`${styles.bar} ${styles.bar1}`}></div>
          <div className={`${styles.bar} ${styles.bar2}`}></div>
          <div className={`${styles.bar} ${styles.bar3}`}></div>
        </div>

        <div className={`${styles['nav-links-container']} ${isOpen ? styles.active : ''}`}>
          <ul className={`${styles['nav-links']} ${isOpen ? styles.active : ''}`}>
            <li><NavLink to="/angebot" id="angebot" className={({isActive}) => (isActive ? "active" : "")} onClick={() => setIsOpen(false)}>Konfigurator</NavLink></li>
            <li><NavLink to="/klassen" id="klassen" className={({isActive}) => (isActive ? "active" : "")} onClick={() => setIsOpen(false)}>Klassen</NavLink></li>
            <li><NavLink to="/kursplan" id="kursplan" className={({isActive}) => (isActive ? "active" : "")} onClick={() => setIsOpen(false)}>Kursplan</NavLink></li>
            <li><NavLink to="/wissenswertes" id="wissenswertes" className={({isActive}) => (isActive ? "active" : "")} onClick={() => setIsOpen(false)}>Wissenswertes</NavLink></li>
            {/* <li><NavLink to="/gutscheine" id="gutscheine" className={({isActive}) => (isActive ? "active" : "")} onClick={() => setIsOpen(false)}>Gutscheine</NavLink></li> */}
            <li><NavLink to="/login" id="login" className={({isActive}) => (isActive ? "active" : "")} onClick={() => setIsOpen(false)}>Login</NavLink></li>
            {/* <li><a href="https://fs16a.mmm-software.at:1016/orange/schueler" target="_blank" rel="noreferrer">Schüler-Login</a></li> */}
          </ul>
          <div className={styles['nav-active-slider']} style={{width: `${activeWidth}px`, left: `${activeLeftOffset}px`}}></div>
        </div>
  
        {/* ✅ Добавлен блок приветствия и выхода */}
        {user && (
          <div className={styles.authBlock}>
            <span className={styles.welcome}>Hallo, {user.first_name}!</span>
            <button onClick={logout} className={styles.logoutBtn}>Logout</button>
          </div>
        )}
      </div>
    </nav>
  );
  
};

export default Navbar;
